export const RECEIVER_GROUPS = [
    {
        key: 'TEAM_LEADERS',
        label: 'Komandų vadovai'
    },
    {
        key: 'ADMINS',
        label: 'Vadovai'
    }
];